
import './App.css';
import { Routes, Route } from 'react-router-dom';
import { BrowserRouter as Router } from 'react-router-dom';
import AboutMe from './pages/AboutMe';
import Projects from './pages/Projects';
import Home from './pages/Home';
import './index.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import Footer from './components/Footer';
import NavBar from './components/NavBar';
import './styles/main.css'

function App() {
  return (
    <Router>
      <div className='home'>
        <section>
          <NavBar />
          <Routes >
            <Route path="/" element={<Home />} />
          </Routes>
          <Footer />
        </section>
      </div>
    </Router>
  );
}

export default App;
